// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__38u7q","fullView":"styles_fullView__Ps9lj"};